export default __webpack_public_path__ + "static/V2_adjusted-b3ff6513f149f54d05d295d7cca2d95f.jpg";